export default "__VITE_ASSET__51350161__"